import { WatchAccountService } from './../../../services/watch-account.service';
import { Component, OnInit } from '@angular/core';
import { PusherService } from '../../../services/pusher.service';
import { SubscriptionService } from '../../../services/subscription.service';
import { Subscription } from 'rxjs';

@Component({
  selector: '[trial-banner]',
  template: require('./account-trial-banner.component.pug'),
  styles: [require('./account-trial-banner.component.css').toString()],
})
export class AccountTrialBannerComponent implements OnInit {
  sub: Subscription = null;
  subTrial: Subscription = null;
  subExpired: Subscription = null;
  subSubscription: Subscription = null;
  subPendingPayment: Subscription = null;
  subPastDue: Subscription = null;

  isTrial = false;
  isExpired = false;
  pendingPayment = false;
  pastDue = false;
  expiredAt = null;
  timer = null;
  timeToExpiry: string;
  subscription = null;
  isSleep = false;

  // -------------------------------------------------------------------
  constructor(
    private pusherService: PusherService,
    private watchAccount: WatchAccountService,
    private subscriptionService: SubscriptionService,
  ) {
    this.watchAccount.resetInfo();
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.subSubscription = this.watchAccount.subscription.subscribe(res => {
      this.subscription = res;
      if (this.subscription) {
        this.expiredAt = null;
      }
    });

    this.subExpired = this.watchAccount.isExpired.subscribe(res => {
      this.isExpired = res;
      if (this.isExpired) {
        this.expiredAt = null;
      }
    });

    this.subPendingPayment = this.watchAccount.pendingPayment.subscribe(res => {
      this.pendingPayment = res;
    });

    this.subPastDue = this.watchAccount.pastDue.subscribe(res => {
      this.pastDue = res;
    });

    this.subTrial = this.watchAccount.isTrial.subscribe(res => {
      this.isTrial = res;
    });

    this.sub = this.subscriptionService
      .subscription(this.watchAccount.accountId().getValue())
      .subscribe(response => {
        console.warn({ response });

        if (response.subscription) {
          this.watchAccount.subscription.next(response.subscription);
          this.isSleep = this.subscription.name === 'sleep';
          if (response.subscription.status === 'incomplete') {
            this.watchAccount.pendingPayment.next(true);
          }
          if (response.subscription.status === 'past_due') {
            this.watchAccount.pastDue.next(true);
          }
        } else {
          this.watchAccount.subscription.next(null);
          this.isSleep = false;

          if (response.expiredAt) {
            this.watchAccount.isTrial.next(true);

            let exp: Date = new Date(response.expiredAt);
            let now: Date = new Date();

            this.isExpired = now > exp;
            this.expiredAt = exp;

            this.watchAccount.isExpired.next(this.isExpired);

            this.checkTimeToExpire();
          } else {
            this.watchAccount.isTrial.next(false);
          }
        }
      });

    this.timer = setInterval(() => {
      this.checkTimeToExpire();
    }, 1000);
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.subExpired) {
      this.subExpired.unsubscribe();
    }
    if (this.subTrial) {
      this.subTrial.unsubscribe();
    }
    if (this.subSubscription) {
      this.subSubscription.unsubscribe();
    }
    if (this.subPendingPayment) {
      this.subPendingPayment.unsubscribe();
    }
    if (this.subPastDue) {
      this.subPastDue.unsubscribe();
    }
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  // -------------------------------------------------------------------
  checkTimeToExpire() {
    if (!this.expiredAt) {
      return;
    }

    let now: any = new Date();
    let diffTime = this.expiredAt - now;

    let diff = diffTime / 1000 / 60;

    if (diff <= 60) {
      if (diff <= 0) {
        this.isExpired = true;
        return;
      }
      this.timeToExpiry = Math.round(diff) + ' minutes';
    } else {
      diff = diff / 60;
      if (diff <= 24) {
        this.timeToExpiry = Math.round(diff) + ' hours';
      } else {
        diff = diff / 24;
        if (diff <= 30) {
          this.timeToExpiry = Math.round(diff) + ' days';
        } else {
          diff = diff / 30;
          this.timeToExpiry = Math.round(diff) + ' months';
        }
      }
    }
  }
}
